//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PixiLoader from './utils/loader'
import { utils } from 'pixi.js'

import SceneManeger from './managers/SceneManager'
import MainScene from './scenes/MainScene'
import { setAPP, APP, RES_TYPE } from './config'

export default {
  name: 'Pixi',
  components: {},
  data () {
    return {
    }
  },
  created() {
    
  },
  async mounted() {
    if(APP) {
      location.reload()
    }
    // create application
    const loader = new PixiLoader(document.getElementById("pixi-root"))

    setAPP(loader.createApplication())

    // preload static resources
    await loader.loadResources();

    // init managers
    SceneManeger.init();

    // show fps
    if (process.env.NODE_ENV !== 'production') {
      SceneManeger.showFPS();
    }

    // load all scenes
    SceneManeger.load('Main', new MainScene([RES_TYPE.BACKGROUND]));
    
    // show entry scene
    SceneManeger.push('Main');
    window.scrollTo((document.getElementById("pixi-root").offsetWidth - window.innerWidth) / 2, 0)
  },
  destroyed() {
    // console.log('destroyed')

    SceneManeger.destroy();
    APP.loader.reset();
    APP.destroy(true);
    utils.destroyTextureCache();
  }
}
